module.exports = __webpack_public_path__ + "img/canvasMenuQuickStyle.eeceb4e1.svg";